import React from "react";
import { Container } from "./styles";

const MasterContainer: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default MasterContainer;
